import {
  IDLESTATUS_AWAY,
  IDLESTATUS_INACTIVE,
  IDLESTATUS_EXPIRED
} from '../../constants/idle-monitor-statuses';

import { signOut } from '../auth-user';

import { actions as toastrActions } from 'react-redux-toastr';

import config from '../../config';
import * as tokenStorage from '../../tools/token-storage';

import moment from 'moment';

const LOG_IDLE_MONITOR = false;
const idleMonitorToastrId = 'idleMonitorToastr';

export const idleStatusDelay = idleStatus => (dispatch, getState) => {
  log(`Getting idle status ${idleStatus} delay`);

  if (idleStatus === IDLESTATUS_AWAY) {
    return config.idleMonitor.awayDelay;
  }
  if (idleStatus === IDLESTATUS_INACTIVE) {
    return config.idleMonitor.inactiveDelay;
  }
  if (idleStatus === IDLESTATUS_EXPIRED) {
    return config.idleMonitor.expiredDelay;
  }
};

export const activeStatusAction = (dispatch, getState) => {
  log(`User became active`);

  dispatch(hideIdleMonitorToastr());

  removeInactivityStatus();

  tokenStorage.keepNativeToken();
  tokenStorage.keepSharedToken();
};

export const idleStatusAction = idleStatus => (dispatch, getState) => {
  setInactivityStatus(idleStatus);

  if (idleStatus === IDLESTATUS_AWAY) {
    log(`User is away.`);
    return;
  }

  if (idleStatus === IDLESTATUS_INACTIVE) {
    log(`User is inactive.`);

    dispatch(showIdleMonitorToastr());
    return;
  }

  if (idleStatus === IDLESTATUS_EXPIRED) {
    log(`User is expired.`);

    dispatch(hideIdleMonitorToastr());
    processSignOut(dispatch, getState);
  }
};

function showIdleMonitorToastr() {
  log('Show idle monitor toastr action...');

  const { expiredDelay } = config.idleMonitor;

  const logoutTimeout = Math.round(expiredDelay / 60 / 1000);

  return toastrActions.add({
    id: idleMonitorToastrId,
    type: 'warning',
    title: 'Are you still there?',
    position: 'top-center',
    message: `Your account will be logged out in ${logoutTimeout} minutes`,
    options: {
      timeOut: expiredDelay,
      showCloseButton: true
    }
  });
}

function hideIdleMonitorToastr() {
  log('Hide idle monitor toastr action...');

  return toastrActions.remove(idleMonitorToastrId);
}

function processSignOut(dispatch, getState) {
  log('Processing sign out');

  const { authUser } = getState();

  if (authUser && authUser.get('userId')) {
    dispatch(signOut());
  }
}

export const getInactivityStatus = () => {
  return localStorage.getItem('inactivity-status');
}

function setInactivityStatus(inactivityStatus) {
  localStorage.setItem('inactivity-status', inactivityStatus);
}

function removeInactivityStatus() {
  localStorage.removeItem('inactivity-status');
}

function log(message, ...rest) {
  if (!config.debug || !LOG_IDLE_MONITOR) {
    return;
  }

  const timestamp = moment().format();

  console.log(`${timestamp} ${message}`, ...rest);
}



// WEBPACK FOOTER //
// ./src/actions/idle-monitor/index.js